import React from 'react';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import LoginMode from '../../Types/LoginMode';
import LoginChangePassword from './ui/LoginChangePassword';
import LoginForgotPassword from './ui/LoginForgotPassword';
import LoginForm from './ui/LoginForm';
import LoginSelectOrganization from './ui/LoginSelectOrganization';
import clsx from 'clsx';
import LoginCreateAccount from './ui/LoginCreateAccount';

const LoginContainer = () => {
  const { loginMode, error } = useTypedSelector((state) => state.login);

  return (
    <>
      {error && (
        <div className={clsx('text-lg', 'text-error-500', 'mb-4')}>
          {error}
        </div>
      )}
      {loginMode == LoginMode.Login && <LoginForm />}
      {loginMode == LoginMode.SelectOrganization && (
        <LoginSelectOrganization />
      )}
      {loginMode == LoginMode.ChangePassword && <LoginChangePassword />}
      {loginMode == LoginMode.ForgotPassword && <LoginForgotPassword />}
      {loginMode == LoginMode.CreateAccount && <LoginCreateAccount />}
    </>
  );
};

export default LoginContainer;
